import React from 'react'
import { useSearchParams } from 'react-router-dom'
import Step3Form from 'components/steps/Step3Form'
import { IApplicationState } from 'components/store/types'
import {
  getCurrentCliniqueId,
  getCurrentPersonType,
  getCurrentTreatmentId,
  getCurrentZawinCode,
} from 'components/core/state/selectors'
import { connect, ConnectedProps } from 'react-redux'
import { AppDispatch } from 'components/store/state/store'
import { updateCurrentStep } from 'components/core/state/actions'
import Step3Zawin from 'components/steps/Step3Zawin'
import { ISetSearchParams } from 'components/core/types'

const mapState = (state: IApplicationState) => ({
  clinique: getCurrentCliniqueId(state),
  personType: getCurrentPersonType(state),
  treatment: getCurrentTreatmentId(state),
  zawinCode: getCurrentZawinCode(state),
})
const mapDispatch = (dispatch: AppDispatch) => ({
  updateStep: (step: number, setSearchParams: ISetSearchParams) => {
    dispatch(updateCurrentStep(step, setSearchParams))
  },
})
const connector = connect(mapState, mapDispatch)

const Step3 = ({
  clinique,
  personType,
  treatment,
  updateStep,
  zawinCode,
}: ConnectedProps<typeof connector>) => {
  const [, setSearchParams] = useSearchParams()
  if (!personType) {
    updateStep(1, setSearchParams)
  }
  if (!clinique || !treatment) {
    updateStep(2, setSearchParams)
  }
  if (zawinCode) {
    return <Step3Zawin url={zawinCode} />
  }
  return <Step3Form />
}
export default connector(Step3)
